export default __webpack_public_path__ + "static/media/lucky-spin-banner.ebe20cc4.webp";